window.FileAPI = {
	staticPath: $('base').data('original')+'static/js/FileAPI/'
};


const FileAPI = require('../../fileapi/FileAPI');

$('body').on('submit','[name=formTrabalheConosco]', function() {
	try	{
		var $self = $(this);

		if ($self.data('enviando')) return false;
		if (!$self.find('.required').validate()) return false;

		$self.data('enviando',true);
		$.fancybox.showLoading();

		var callback = function(resp) {
			if (undefined != resp.redirect_url) {
				location.href = resp.redirect_url;
				return;
			}

			$.fancybox.hideLoading();
			$self.data('enviando',false);

			if (undefined != resp.popup_url) {
				$.fancybox.open([{
					href: resp.popup_url,
					type: 'ajax'
				}],{});
				return;
			}

			alert(resp.msg);

			if (resp.success) {
				$self.find(':text,textarea,select').val('');
			}
		};

		$.ajax({
			url: $self.attr('action'),
			type: 'post',
			dataType: 'json',
			data: $self.serializeArray(),
			success: callback,
			error: function() {
				callback({
					success: false,
					msg: "Não foi possível enviar o formulário."
				});
			}
		});

	} catch (e) {
		console.log(e);
	}

	return false;
});

$('body').on('click','[name=formTrabalheConosco] .btn-add-curriculo', function() {
	var $self = $(this);
	var $form = $self.closest('form');
	var $span = $self.find('span');

	var $el = $(`
			<div>
				<div class="js-FileAPI-wrapper upload-btn">
					<input type="file" />
				</div>
			</div>
		`);
	var $input = $el.find('input');
	var input = $input[0];

	FileAPI.event.on(input, 'change', function(evt) {
		var files = FileAPI.getFiles(evt);

		FileAPI.filterFiles(files, function(file, info) {
			return true;
		}, function(files, rejected) {
			if (files.length) {
				FileAPI.each(files, function(file) {					
					FileAPI.readAsDataURL(file, function(e) {
						if (e.type == 'load') {
							var binaryString = e.result;
							$('<input />').attr('type','hidden')
								.attr('name',$self.attr('name')+'[content]')
								.val(binaryString)
								.appendTo($form);

							$('<input />').attr('type','hidden')
								.attr('name',$self.attr('name')+'[name]')
								.val(file.name)
								.appendTo($form);

							$('<input />').attr('type','hidden')
								.attr('name',$self.attr('name')+'[type]')
								.val(file.type)
								.appendTo($form);

							$('<input />').attr('type','hidden')
								.attr('name',$self.attr('name')+'[size]')
								.val(file.size)
								.appendTo($form);


							$span.html(file.name);

						} else if (e.type == 'progress') {
							var pr = Math.round(e.loaded/e.total * 100);
						} else {
							console.log(e);
						}
					});
				});
			}
		});
	});

	$form.find('input[type=hidden][name='+$self.attr('name')+']').remove();
	$span.html('Nenhum arquivo selecionado');

	$input.trigger('click');
	return false;
});


//////////////////
// WEBPACK FOOTER
// ../src/contato/trabalhe-conosco.js
// module id = 70
// module chunks = 0